import { render, staticRenderFns } from "./OvertimeLimitStatus.vue?vue&type=template&id=355527a1&"
import script from "./OvertimeLimitStatus.vue?vue&type=script&lang=js&"
export * from "./OvertimeLimitStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports